c.team_directory = {
	init : function(){
		var directory_wrap = $( '#team-directory' );
		if( directory_wrap.length ){
			c.fn.react_render( Window.Directory, team_directory, directory_wrap.get( 0 ) );
		}
	}

};